import React from 'react';
import { useParams } from 'react-router-dom';
import NotFound from '../404/NotFound';

const DOCUMENT_MAP = {
  'privacypolicy2024.pdf':
    'https://assets.ctfassets.net/w8xk6b5tz811/5Hn6M4bKGRH7JoDO2GQ4d1/895231f1b1335a76938aac0086ab9826/PrivacyPolicy2024.pdf',
  'PAIA-manual-2026.pdf':
    'https://assets.ctfassets.net/w8xk6b5tz811/3CClsdLTY12NHDfGlFD0hp/bdfe4cd6c38c658fd56fcbfadb7ca3e2/PAIA-manual-2026.pdf',
  'Conflict_of_Interest_Management_Policy_2024.pdf':
    'https://assets.ctfassets.net/w8xk6b5tz811/5SmQaX157BZzitnirpMLh5/6d71405ec1492e109e3b643752419963/Conflict_of_Interest_Management_Policy_2024.pdf',
};

const DocumentPage = () => {
  const { slug } = useParams();
  const url = DOCUMENT_MAP[slug];

  if (!url) return <NotFound />;

  return (
    <iframe
      src={url}
      title={slug}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  );
};

export default DocumentPage;
